//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'footer'
}
